import { render, staticRenderFns } from "./AvailabilityProvider.vue?vue&type=template&id=bde7c49c"
import script from "./AvailabilityProvider.vue?vue&type=script&lang=ts"
export * from "./AvailabilityProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports